import OButton from "./OButton";
import { OmyConst } from "../../OmyConst";
import Omy from "../../Omy";

export default class OButtonTween extends OButton {
    constructor(outTexture, atlas = null, overTexture = null, downTexture = null, blockrTexture = null, json = null) {
        super(outTexture, atlas, overTexture, downTexture, blockrTexture, json);
        this._oType = OmyConst.OMY_BUTTON_TWEEN;

        this._overScaleX = this._gdConf["overScaleX"] || this._gdConf["overScale"] || .9;
        this._overScaleY = this._gdConf["overScaleY"] || this._gdConf["overScale"] || .9;
        this._downScaleX = this._gdConf["downScaleX"] || this._gdConf["downScale"] || .8;
        this._downScaleY = this._gdConf["downScaleY"] || this._gdConf["downScale"] || .8;

        this._saveScaleX = 1;
        this._saveScaleY = 1;
        // this.setPivot(this.width * .5, this.height * .5);

    }

    revive() {
        super.revive();
        this.setScale(this._saveScaleX, this._saveScaleY);
        return this;
    }

    destroy(options) {
        this._gdConf = null;
        Omy.remove.tween(this);
        return super.destroy(options);
    }

    kill() {
        Omy.remove.tween(this);
        return super.kill();
    }

    _onOverHandler() {
        Omy.add.tween(this.scale,
            { x: this._saveScaleX * this._overScaleX, y: this._saveScaleY * this._overScaleY },
            .1);
        super._onOverHandler();
    }

    _onOutHandler() {
        Omy.add.tween(this.scale, { x: this._saveScaleX, y: this._saveScaleY }, .1);
        super._onOutHandler();
    }

    _onDownHandler() {
        Omy.add.tween(this.scale,
            { x: this._saveScaleX * this._downScaleX, y: this._saveScaleY * this._downScaleY },
            .1);
        super._onDownHandler();
    }

    _onUpHandler() {
        Omy.add.tween(this.scale, { x: this._saveScaleX, y: this._saveScaleY }, .1);
        super._onUpHandler();
    }

    setScale(ax, ay) {
        this._saveScaleX = ax;
        this._saveScaleY = ay;
        this.scale.set(ax, ay);
    }

    get scaleX() {
        return this.scale.x;
    }

    set scaleX(value) {
        this._saveScaleX = value;
        this.scale.x = value;
    }

    get scaleY() {
        return this.scale.y;
    }

    set scaleY(value) {
        this._saveScaleY = value;
        this.scale.y = value;
    }
}
